import { render, staticRenderFns } from "./SupportClientsTable.vue?vue&type=template&id=95ef65d8&scoped=true"
import script from "./SupportClientsTable.vue?vue&type=script&lang=js"
export * from "./SupportClientsTable.vue?vue&type=script&lang=js"
import style0 from "./SupportClientsTable.vue?vue&type=style&index=0&id=95ef65d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef65d8",
  null
  
)

export default component.exports